import {
  LOYALTY_CONFIG_GET,
  LOYALTY_CONFIG_UPDATE,
  LOYALTY_MEMBER_GET,
  LOYALTY_EXPIRY_ROWS_GET,
  LOYALTY_REDEEM_PREVIEW,
  LOYALTY_OTP_REQUEST,
  LOYALTY_OTP_VERIFY,
  LOYALTY_OTP_STATUS,
  LOYALTY_REDEEM_APPLY,
  LOYALTY_REDEEM_REVERSE,
  LOYALTY_ADJUST,
  LOYALTY_ENROL,
  LOYALTY_RUNTIME_GET,
} from "../types";

const withCallbacks = (type, data) => (onSuccess, onError) => ({
  type,
  data,
  onSuccess,
  onError,
});

export const loyaltyConfigGetAction = (onSuccess, onError) => ({
  type: LOYALTY_CONFIG_GET,
  onSuccess,
  onError,
});

export const loyaltyConfigUpdateAction = (data, onSuccess, onError) => ({
  type: LOYALTY_CONFIG_UPDATE,
  data,
  onSuccess,
  onError,
});

export const loyaltyMemberGetAction = (data, onSuccess, onError) => ({
  type: LOYALTY_MEMBER_GET,
  data,
  onSuccess,
  onError,
});

export const loyaltyExpiryRowsGetAction = (data, onSuccess, onError) => ({
  type: LOYALTY_EXPIRY_ROWS_GET,
  data,
  onSuccess,
  onError,
});

export const loyaltyRedeemPreviewAction = (data, onSuccess, onError) => ({
  type: LOYALTY_REDEEM_PREVIEW,
  data,
  onSuccess,
  onError,
});

export const loyaltyOtpRequestAction = (data, onSuccess, onError) => ({
  type: LOYALTY_OTP_REQUEST,
  data,
  onSuccess,
  onError,
});

export const loyaltyOtpVerifyAction = (data, onSuccess, onError) => ({
  type: LOYALTY_OTP_VERIFY,
  data,
  onSuccess,
  onError,
});

export const loyaltyOtpStatusAction = (data, onSuccess, onError) => ({
  type: LOYALTY_OTP_STATUS,
  data,
  onSuccess,
  onError,
});

export const loyaltyRedeemApplyAction = (data, onSuccess, onError) => ({
  type: LOYALTY_REDEEM_APPLY,
  data,
  onSuccess,
  onError,
});

export const loyaltyRedeemReverseAction = (data, onSuccess, onError) => ({
  type: LOYALTY_REDEEM_REVERSE,
  data,
  onSuccess,
  onError,
});

export const loyaltyAdjustAction = (data, onSuccess, onError) => ({
  type: LOYALTY_ADJUST,
  data,
  onSuccess,
  onError,
});

export const loyaltyEnrolAction = (data, onSuccess, onError) => ({
  type: LOYALTY_ENROL,
  data,
  onSuccess,
  onError,
});

export const loyaltyRuntimeGetAction = (onSuccess, onError) => ({
  type: LOYALTY_RUNTIME_GET,
  onSuccess,
  onError,
});
